/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */

import React from 'react';
import {withRouter} from 'react-router';

import {Glyphicon, Button, Grid, Row, Col} from 'react-bootstrap';
import ReactSpinner from 'react-spinjs';
import userAPI from '../../../api/awsUserAPI';
import ActionResult from '../../../stores/ActionResult';
import EditDealerView from './editDealerView.react';
import APIActions from '../../../actions/apiActions';
import DealerStore from '../../../stores/DealerStore';
import UIHelpers from '../../../library/UIHelpers';
import AppConstants from '../../../constants/AppConstants';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import DataHelper from '../../../library/DataHelpers';
import DealerAPI from '../../../api/awsDealerApi';


class ManageDealersView extends React.Component {
    constructor(props) {
        console.log("[ManageDealersView] - initialisation");
        super(props);

        this.addNewDealer = this.addNewDealer.bind(this);
        this.onActionComplete = this.onActionComplete.bind(this);
        this.actionDelete = this.actionDelete.bind(this);
        this.actionEdit = this.actionEdit.bind(this);
        this.dealerEditHandler = this.dealerEditHandler.bind(this);
        this.loadDealers = this.loadDealers.bind(this);
        this.dealerSaveHandler = this.dealerSaveHandler.bind(this);

        this._onDealerChange = this._onDealerChange.bind(this);

        this.state = {
            activeTab : 1,
            jobNames: null,
            addingDealer : false,
            loading : false,
            dealers : [],
            editingDealer : null,
            editMode : null
        };

    }

    componentDidMount() {
        console.log("[ManageDealersView] - componentDidMount");
        DealerStore.addChangeListener(this._onDealerChange) ;
        this.loadDealers() ;
    }

    componentWillUnmount() {
        console.log("[ManageDealersView] - componentWillUnmount");
        DealerStore.removeChangeListener(this._onDealerChange) ;
    }

    _onDealerChange(payload) {
        if (payload) {
            switch (payload) {
                case AppConstants.ALL_DEALERS:
                    var s = this.state ;
                    s.dealers = DealerStore.dealers() ;
                    s.dealerView = s.dealers.map(item => ({id: item.dealerId, name: item.name, size: "Small", dealer: item}));
                    s.loading = false ;
                    this.setState(s);
                    break ;
                case AppConstants.DELETE_DEALER:
                    this.loadDealers() ;
                    return ;
                case AppConstants.DELETE_DEALER_ERR:
                    UIHelpers.showMessage("A problem occurred deleting a dealer");
                    return ;
                default: break ;
            }
        }
    }

    dealerSaveHandler(cs) {
        switch (cs.status) {
            case "OK":
                console.log("DEALER SAVED - RELOADING:" + cs.result.state);
                UIHelpers.showMessage("Changes saved");
                this.loadDealers() ;
                break;
            case "FAIL":
                console.log("ERROR SAVING DEALER");
                UIHelpers.showMessage("A problem occurred saving those Dealer changes");
                this.loadDealers() ;
                break;
            default:
                break;
        }
    }

    onActionComplete(ss) {
        if (ss === undefined || ss === null) {
            return ; // shouldn't happen but just in case'
        }

        switch (ss.action) {
            case "SAVE_DEALER" : this.dealerSaveHandler(ss.result) ; break ;
            default:
                break; // Unexpected result - not expected
        }
    }

    addNewDealer() {
        console.log("Add new user");
        var s = this.state ;
        s.addingDealer = !s.addingDealer ;
        s.editingDealer = null ;
        s.editMode="ADD";
        this.setState(s);
    }

    loadDealers() {
        var s = this.state ;
        s.loading = true ;
        this.setState(s);
        APIActions.allDealers();
    }

    actionDelete(dealer) {
        console.log("[USER] - delete dealer: " + JSON.stringify(dealer));
        if (!UIHelpers.confirmAction("Are you sure you want to delete this Dealer?")) {
            return ;
        }

        APIActions.deleteDealer(dealer);
    }

    actionEdit(u) {
        console.log("[USER] - edit user: " + JSON.stringify(u));

        DealerStore.clearDealer() ;
        var s = this.state ;
        s.editingDealer = DataHelper.deepCopy(u) ;
        s.addingDealer = true ;
        s.editMode = "EDIT";
        APIActions.allDealerUsers(u.dealerId);
        DealerAPI.allDealerJobs(u.dealerId) ;
        this.setState(s);
    }

    dealerEditHandler(state) {
        // state => {cancelled: false, dealer : dealer}
        var s = this.state ;
        s.addingDealer = false ;
        s.editingDealer = null ;
        this.setState(s);

        if (!state.cancelled) {
            userAPI.saveDealer(state.dealer, ActionResult.make("SAVE_DEALER",this.onActionComplete));
        }
    }

    handleTypeSelect(event) {
        event.preventDefault();
        var s = this.state ;
        s.activeTab = event ;
        this.setState(s);
    }

    cellButton(cell, row, enumObject, rowIndex) {
        return (
            <div>
                <Button bsStyle="danger" bsSize="xsmall" title="Delete Dealer" onClick={this.actionDelete.bind(this,row)}><Glyphicon glyph="trash"/></Button>{'  '}
                <Button bsStyle="info" bsSize="xsmall" title="Edit Dealer" onClick={this.actionEdit.bind(this,row)}><Glyphicon glyph="edit"/></Button>{'  '}
            </div>
        );
    }

    render() {
        const selectRowProp = {
            bgColor: 'lightblue'
        };

        const options = {
            sortName: 'name',  // default sort column name
            sortOrder: 'asc',  // default sort order
            sizePerPage: 15,
            hideSizePerPage: true,
        };

        var dealerList = this.state.dealers || [];
        var self = this ;
        return (
            <div>
                <Grid>
                    <Row hidden={this.state.addingDealer}>
                        <Col>
                            <Button bsStyle="success" bsSize="sm" onClick={this.loadDealers}><Glyphicon glyph="refresh"/>{' '}Refresh Dealers</Button>{' '}
                            <Button bsStyle="success" bsSize="sm" onClick={this.addNewDealer}><Glyphicon glyph="plus"/>{' '}Add Dealer</Button>
                        </Col>
                    </Row>
                    <Row ><Col><br /></Col></Row>
                    <Row hidden={!this.state.addingDealer}>
                        <Col>
                            <EditDealerView closeHandler={this.dealerEditHandler} dealer={this.state.editingDealer} mode={this.state.editMode}/>
                        </Col>
                    </Row>

                    <Row hidden={this.state.addingDealer}>
                        <BootstrapTable data={ dealerList }
                            selectRow={ selectRowProp }
                            options={ options }
                            hover focus search pagination
                            tableContainerClass='orbit-table-container'>

                            <TableHeaderColumn dataField='dealerId' hidden={true} isKey >ID</TableHeaderColumn>
                            <TableHeaderColumn dataField='name' tdStyle={ { whiteSpace: 'normal' } }>Name</TableHeaderColumn>
                            <TableHeaderColumn dataField='address' tdStyle={ { whiteSpace: 'normal' } }>Address</TableHeaderColumn>
                            <TableHeaderColumn dataField='contactPhone' >Contact Phone Number</TableHeaderColumn>
                            <TableHeaderColumn dataField='contactName' tdStyle={ { whiteSpace: 'normal' } }>Main Contact Name</TableHeaderColumn>
                            <TableHeaderColumn dataField='svcContactPhone' >Svc Mgr Phone</TableHeaderColumn>
                            <TableHeaderColumn dataField='contactEmail' tdStyle={ { whiteSpace: 'normal' } }>Email</TableHeaderColumn>
                            <TableHeaderColumn dataField='button' width='90px' dataFormat={this.cellButton.bind(this)}></TableHeaderColumn>
                        </BootstrapTable>
                    </Row>
                     <Row>
                        <Col>
                        </Col>
                    </Row>
                    <Row hidden={!this.state.loading}>
                        <ReactSpinner/>
                    </Row>
                </Grid>
            </div>
        );
    }
}

export default withRouter(ManageDealersView);



// WEBPACK FOOTER //
// ./src/app/components/admin/dealers/manageDealersView.js